import type { MessageVisibilityMode } from "@/api/models"

import { Chat } from "./chat"

type ExplorerLoadingStateProps = {
  currentUserAccessMode?: MessageVisibilityMode
  lastQuestion?: string
  sessionId?: string
}

export function ExplorerLoadingState({
  currentUserAccessMode,
  lastQuestion,
  sessionId,
}: ExplorerLoadingStateProps) {
  return (
    <>
      {currentUserAccessMode !== "specific_message" && lastQuestion && (
        <Chat.UserMessage message={lastQuestion} />
      )}
      <Chat.Loading citationSection={sessionId} />
    </>
  )
}
